<template>
<div class="chapter">
<div class="inner_page">
<div epub:type="dedication" id="uRq8ewU9g9yWVNhfHFCQS8B">
<p class="ORIM-Chapter-Title-Page-Break--Body-" id="uHZvhCOzIUEI294XJr64Cz9"></p>
<p class="center"><em class="italic">For my family in Vermont</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AlmostDark3.vue?7212f738